import { useState, useEffect } from 'react';
import debounce from 'lodash.debounce';

function useDebouncedValue(input, delay) {
  const [debouncedValue, setDebouncedValue] = useState(input);

  useEffect(() => {
    const handler = debounce(() => setDebouncedValue(input), delay);
    handler();

    return () => handler.cancel();
  }, [input, delay]);

  return debouncedValue;
}

export default useDebouncedValue;
